(() => {
  const reviewLogoUrl = 'https://cdn.shopify.com/s/files/1/1007/8493/1154/files/logotipo-de-comprimible-tienda-sofas-comprimidos-caja.png?v=1781618179&width=220';

  const normalizeAccessibility = (root = document) => {
    const scope = root instanceof Element || root instanceof Document ? root : document;
    const matchingElements = (selector) => [
      ...(scope.matches?.(selector) ? [scope] : []),
      ...scope.querySelectorAll(selector),
    ];

    matchingElements('ul.splide__list[role="presentation"]').forEach((list) => {
      list.removeAttribute('role');
    });

    matchingElements('li.splide__slide[role="tabpanel"]').forEach((slide) => {
      slide.removeAttribute('role');
    });

    matchingElements('iframe[src*="google.com/maps"]:not([title])').forEach((frame) => {
      frame.setAttribute('title', 'Mapa de la tienda Comprimible en Sevilla');
    });

    const merchantFrame = matchingElements('#merchantwidgetiframe')[0];
    if (merchantFrame && !merchantFrame.hasAttribute('title')) {
      merchantFrame.setAttribute('title', 'Valoraciones de Google de Comprimible');
    }

    matchingElements('.grp-entangle-item span.grp-read-more').forEach((label) => {
      label.style.setProperty('color', '#444445', 'important');
    });

    matchingElements('.grp-entangle-badge-thumbnail img.grp-entangle-source-image').forEach((image) => {
      image.removeAttribute('srcset');
      image.setAttribute('loading', 'eager');
      if (image.getAttribute('src') !== reviewLogoUrl) {
        image.setAttribute('src', reviewLogoUrl);
      }
      image.setAttribute('alt', 'Logotipo de Comprimible, tienda de sofás comprimidos en caja');
      image.dataset.comprimibleReviewLogoFixed = 'true';
    });

    matchingElements('.grp-entangle-badge .grp-entangle-heading--small').forEach((heading) => {
      if (heading.textContent.toLowerCase().includes('comprimible')) {
        heading.textContent = 'Comprimible · Sofás comprimidos en caja';
      }
    });

    if (
      window.grp_app_metadata
      && typeof window.grp_app_metadata.profile_pic === 'string'
      && window.grp_app_metadata.profile_pic !== reviewLogoUrl
    ) {
      window.grp_app_metadata.profile_pic = reviewLogoUrl;
    }

    matchingElements('.grp-slider-pagination-wrapper').forEach((pagination) => {
      const widget = pagination.closest('.grp-entangle--root');
      const layout = widget?.querySelector('.grp-entangle-swipper-badge-wrapper');
      if (!layout) return;

      pagination.style.left = '0px';
      pagination.style.position = 'relative';
      const layoutRect = layout.getBoundingClientRect();
      const paginationRect = pagination.getBoundingClientRect();
      const offset = (layoutRect.left + layoutRect.width / 2)
        - (paginationRect.left + paginationRect.width / 2);
      pagination.style.left = `${Math.round(offset)}px`;
    });
  };

  const start = () => {
    normalizeAccessibility();

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          normalizeAccessibility(mutation.target);
          return;
        }

        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            normalizeAccessibility(node);
          }
        });
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['role', 'src', 'srcset'],
    });

    window.addEventListener('resize', () => normalizeAccessibility(), { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
